import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'kwo-connect-blocker',
	templateUrl: './kwo-connect-blocker.component.html',
	styleUrls: ['./kwo-connect-blocker.component.scss'],
	host: { 'class': '' },
	standalone: true,
	imports: [CommonModule, FaIconComponent, MatDialogModule, TranslateModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class KWOConnectBlockerComponent implements OnInit {

	constructor(public dialogRef: MatDialogRef<KWOConnectBlockerComponent>,
		private router: Router) { }

	ngOnInit(): void {

	}

	navigateUpgrade() {

		this.router.navigate(['/account/kwo-connect']);
	}

	goToLogin() {

		this.dialogRef.close();
		this.router.navigate(['/inloggen']);
	}
}